module.exports = __webpack_public_path__ + "img/potencia_b_gray.aeece0f4.svg";